import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function HelpDialogContent() {
  return (
    <Box sx={{ mb: "3em" }}>
      <Typography>
        Please click&nbsp;
        <a
          target="_blank"
          href={`${process.env.PUBLIC_URL}/resources/HI-DOH-INDUSTRY-TM.pdf`}
          rel="noreferrer"
        >
          here to view the training material
        </a>
      </Typography>
      <Typography>
        You can quickly find answers to Frequently Asked Questions (FAQS){" "}
        <a href="https://health.hawaii.gov/medicalcannabis">here</a>
      </Typography>
      <Typography>
        If you are a dispensary or facility and have a policy or procedural
        question, please contact the Hawaii Office of Medical Cannabis Control
        and Regulation (OMCCR) at&nbsp;
        <a href="mailto:MedCannabis.Dispensary@doh.hawaii.gov" target="_top">
          MedCannabis.Dispensary@doh.hawaii.gov
        </a>{" "}
        <>
          <span> or </span>
          <a href="tel:808-692-7450">808-692-7450</a>{" "}
        </>
        . Thank you!
      </Typography>

      <Typography>
        If you are an Individual (Patient, Practitioner, Caregiver, Agent) or a
        business other than dispensary and have a policy or procedural question,
        please contact the Hawaii Office of Medical Cannabis Control and
        Regulation (OMCCR) at&nbsp;
        <a href="mailto:MedCannabis.Dispensary@doh.hawaii.gov" target="_top">
          MedCannabis.Dispensary@doh.hawaii.gov
        </a>{" "}
        <>
          <span> or </span>
          <a href="tel:808-692-7450">808-692-7450</a>{" "}
        </>
        . Thank you!
      </Typography>

      <Typography>
        <Typography>
          If you are a Hemp business and have a policy or procedural question,
          please contact the Office of Medical Cannabis Control and Regulation
          (OMCCR) at&nbsp;
          <a href="mailto:DOH.Hemp@DOH.Hawaii.gov" target="_top">
            DOH.Hemp@DOH.Hawaii.gov
          </a>{" "}
          <>
            <span> or </span>
            <a href="tel:808-692-7450">808-692-7450</a>{" "}
          </>
          . Thank you!
        </Typography>
      </Typography>
      <Typography>
        For technical support and payment questions, please contact NIC Hawaii
        at&nbsp;
        <a href="mailto:nlssupport-hi-doh@tylertech.com" target="_top">
          nlssupport-hi-doh@tylertech.com
        </a>{" "}
        <>
          <span> or </span>
          <a href="tel:808-692-7450">808-692-7450</a>{" "}
        </>
      </Typography>
    </Box>
  );
}

export default HelpDialogContent;
